export default "__VITE_ASSET__DgVN2Wbc__"